"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var IncompatibleConversionTypeException_1 = require("../IncompatibleConversionTypeException");
var Measure_1 = require("../Measure");
var Liter_1 = require("./Liter");
var __1 = require("..");
var VolumeMeasure = /** @class */ (function (_super) {
    __extends(VolumeMeasure, _super);
    function VolumeMeasure(value, unit, arg3) {
        var _this = _super.call(this, value, unit) || this;
        if (arg3 && arg3 instanceof __1.DensityMeasure) {
            _this._density = arg3;
        }
        else if (arg3 && arg3 > 0) {
            _this._density = new __1.DensityMeasure(arg3, __1.SpecificGravity.Self);
        }
        return _this;
    }
    Object.defineProperty(VolumeMeasure.prototype, "Density", {
        get: function () {
            return this._density;
        },
        set: function (value) {
            this._density = value;
        },
        enumerable: true,
        configurable: true
    });
    VolumeMeasure.prototype.CreateAs = function (targetUnit) {
        if (!(targetUnit instanceof __1.VolumeUnit) &&
            !(targetUnit instanceof __1.PackageUnit) &&
            !(targetUnit instanceof __1.MassAndWeightUnit)) {
            throw new IncompatibleConversionTypeException_1.IncompatibleConversionTypeException(this.Unit, targetUnit);
        }
        if (targetUnit instanceof __1.PackageUnit &&
            !(targetUnit.PartUnit.Unit instanceof __1.VolumeUnit)) {
            throw new IncompatibleConversionTypeException_1.IncompatibleConversionTypeException(this.Unit, targetUnit);
        }
        if (targetUnit instanceof __1.MassAndWeightUnit && !this.Density) {
            throw new IncompatibleConversionTypeException_1.IncompatibleConversionTypeException(this.Unit, targetUnit);
        }
        var sourceConversionFactor = this.Unit.ConversionFactor;
        var targetConversionFactor = targetUnit.ConversionFactor;
        var targetValue = 0;
        if (targetUnit instanceof __1.VolumeUnit) {
            targetValue =
                (this.Value * sourceConversionFactor) / targetConversionFactor;
            return new VolumeMeasure(targetValue, targetUnit, this.Density);
        }
        else if (targetUnit instanceof __1.MassAndWeightUnit && this.Density) {
            var liters = this.GetValueAs(Liter_1.Liter.Self);
            var sg = this.Density.GetValueAs(__1.SpecificGravity.Self);
            var kilos = new __1.MassAndWeightMeasure(liters * sg, __1.Kilogram.Self);
            kilos.Density = this.Density;
            return kilos.CreateAs(targetUnit);
        }
        else {
            var targetpartConversionFactor = targetUnit
                .PartUnit.ConversionFactor;
            targetValue =
                (this.Value * sourceConversionFactor) /
                    targetpartConversionFactor /
                    targetConversionFactor;
            return new __1.PackageMeasure(targetValue, targetUnit);
        }
    };
    VolumeMeasure.prototype.CanConvertTo = function (targetUnit) {
        return (targetUnit instanceof __1.VolumeUnit ||
            (targetUnit instanceof __1.MassAndWeightUnit && this.Density !== null) ||
            (targetUnit instanceof __1.PackageUnit &&
                targetUnit.PartUnit.Unit instanceof __1.VolumeUnit));
    };
    VolumeMeasure.DefaultUnit = Liter_1.Liter.Self;
    return VolumeMeasure;
}(Measure_1.Measure));
exports.VolumeMeasure = VolumeMeasure;
